module.exports = __webpack_public_path__ + "media/build-kiosks.5b86db8d.mp4";